import ProjectsPage from '../../components/ProjectsPage'

const Work = () => <ProjectsPage mode='work' />

export default Work
